// Bilingual (English + Marathi) content for the public policy pages.
// Block types: { t: "p", text } | { t: "h2", text } | { t: "ul", items: [] }
//              | { t: "email", text, mail } | { t: "contact" }

export const LEGAL = {
  privacy: {
    en: {
      title: "Privacy Policy",
      effectiveDate: "15/08/2026",
      blocks: [
        { t: "p", text: "Welcome to Dairy Hub ERP (“we”, “us”, “our”). This Privacy Policy explains how we collect, use, store, and protect information when you use our website and Dairy Hub ERP software services." },
        { t: "h2", text: "Information We Collect" },
        { t: "ul", items: ["Name", "Business/farm/company name", "Email address", "Mobile number", "Login credentials", "Billing and subscription information", "Information entered into the Dairy Hub ERP application", "Payment and transaction details", "Device, browser, IP address, and basic technical information"] },
        { t: "h2", text: "How We Use Information" },
        { t: "ul", items: ["Create and manage accounts", "Provide Dairy Hub ERP services", "Process subscriptions and payments", "Maintain payment and subscription records", "Provide customer support", "Send account and billing notifications", "Improve security and prevent fraud", "Improve our services", "Comply with applicable laws"] },
        { t: "h2", text: "Payments" },
        { t: "p", text: "Payments may be processed through Razorpay or other authorized payment providers. We may receive payment ID, order/subscription ID, amount, status, and transaction date. We do not store complete card numbers, CVV, UPI PIN, or other sensitive payment credentials." },
        { t: "h2", text: "Data Security" },
        { t: "p", text: "We use reasonable technical and organizational measures to protect user information. However, no internet service can guarantee absolute security." },
        { t: "h2", text: "Data Sharing" },
        { t: "p", text: "Information may be shared with payment providers, hosting providers, notification providers, service providers, or authorities where legally required. We do not sell personal information." },
        { t: "h2", text: "Account Data" },
        { t: "p", text: "Users are responsible for maintaining the security of their login credentials." },
        { t: "h2", text: "Data Retention" },
        { t: "p", text: "Information may be retained as reasonably necessary for service delivery, transaction records, security, dispute resolution, and legal requirements." },
        { t: "h2", text: "Your Rights" },
        { t: "p", text: "Subject to applicable law, users may request access, correction, or deletion of personal information." },
        { t: "h2", text: "Policy Changes" },
        { t: "p", text: "We may update this policy from time to time. Updated versions will be posted on this page." },
        { t: "contact" },
      ],
    },
    mr: {
      title: "गोपनीयता धोरण",
      effectiveDate: "१५/०८/२०२६",
      blocks: [
        { t: "p", text: "Dairy Hub ERP (“आम्ही”, “आमचे”) मध्ये आपले स्वागत आहे. आपण आमची वेबसाइट व Dairy Hub ERP सॉफ्टवेअर सेवा वापरता तेव्हा आम्ही माहिती कशी गोळा करतो, वापरतो, साठवतो व सुरक्षित ठेवतो हे या गोपनीयता धोरणात स्पष्ट केले आहे." },
        { t: "h2", text: "आम्ही गोळा करत असलेली माहिती" },
        { t: "ul", items: ["नाव", "व्यवसाय/शेती/कंपनीचे नाव", "ईमेल पत्ता", "मोबाईल नंबर", "लॉगिन क्रेडेन्शियल्स", "बिलिंग व सबस्क्रिप्शन माहिती", "Dairy Hub ERP अ‍ॅप्लिकेशनमध्ये भरलेली माहिती", "पेमेंट व व्यवहार तपशील", "डिव्हाइस, ब्राउझर, IP पत्ता व मूलभूत तांत्रिक माहिती"] },
        { t: "h2", text: "आम्ही माहिती कशी वापरतो" },
        { t: "ul", items: ["खाती तयार करणे व व्यवस्थापित करणे", "Dairy Hub ERP सेवा पुरवणे", "सबस्क्रिप्शन व पेमेंट प्रक्रिया करणे", "पेमेंट व सबस्क्रिप्शन नोंदी ठेवणे", "ग्राहक सहाय्य पुरवणे", "खाते व बिलिंग सूचना पाठवणे", "सुरक्षा सुधारणे व फसवणूक रोखणे", "आमच्या सेवा सुधारणे", "लागू कायद्यांचे पालन करणे"] },
        { t: "h2", text: "पेमेंट्स" },
        { t: "p", text: "पेमेंट Razorpay किंवा इतर अधिकृत पेमेंट प्रदात्यांमार्फत प्रक्रिया केली जाऊ शकतात. आम्हाला पेमेंट आयडी, ऑर्डर/सबस्क्रिप्शन आयडी, रक्कम, स्थिती व व्यवहार तारीख मिळू शकते. आम्ही संपूर्ण कार्ड नंबर, CVV, UPI PIN किंवा इतर संवेदनशील पेमेंट क्रेडेन्शियल्स साठवत नाही." },
        { t: "h2", text: "डेटा सुरक्षा" },
        { t: "p", text: "वापरकर्त्यांची माहिती सुरक्षित ठेवण्यासाठी आम्ही योग्य तांत्रिक व संस्थात्मक उपाय वापरतो. मात्र, कोणतीही इंटरनेट सेवा पूर्ण सुरक्षिततेची हमी देऊ शकत नाही." },
        { t: "h2", text: "डेटा शेअरिंग" },
        { t: "p", text: "कायदेशीरदृष्ट्या आवश्यक असल्यास माहिती पेमेंट प्रदाते, होस्टिंग प्रदाते, सूचना प्रदाते, सेवा प्रदाते किंवा अधिकाऱ्यांसोबत शेअर केली जाऊ शकते. आम्ही वैयक्तिक माहिती विकत नाही." },
        { t: "h2", text: "खाते डेटा" },
        { t: "p", text: "आपल्या लॉगिन क्रेडेन्शियल्सची सुरक्षा राखण्याची जबाबदारी वापरकर्त्यांची आहे." },
        { t: "h2", text: "डेटा साठवणूक" },
        { t: "p", text: "सेवा पुरवठा, व्यवहार नोंदी, सुरक्षा, वाद निराकरण व कायदेशीर आवश्यकतांसाठी आवश्यक असेल तितक्या कालावधीसाठी माहिती साठवली जाऊ शकते." },
        { t: "h2", text: "आपले हक्क" },
        { t: "p", text: "लागू कायद्याच्या अधीन राहून, वापरकर्ते वैयक्तिक माहितीचा प्रवेश, दुरुस्ती किंवा हटवण्याची विनंती करू शकतात." },
        { t: "h2", text: "धोरणातील बदल" },
        { t: "p", text: "आम्ही हे धोरण वेळोवेळी अद्ययावत करू शकतो. अद्ययावत आवृत्त्या या पानावर प्रसिद्ध केल्या जातील." },
        { t: "contact" },
      ],
    },
  },

  terms: {
    en: {
      title: "Terms & Conditions",
      effectiveDate: "15/08/2026",
      blocks: [
        { t: "p", text: "These Terms govern the use of the Dairy Hub ERP website and software services provided by Dairy Hub ERP, owned and operated by Sunil Gangadhar Kamble." },
        { t: "p", text: "By registering or using Dairy Hub ERP, you agree to these Terms." },
        { t: "h2", text: "Dairy Hub ERP" },
        { t: "p", text: "Dairy Hub ERP is a software service designed to help businesses manage dairy-related operations, records, users, subscriptions, and related activities." },
        { t: "h2", text: "Account Registration" },
        { t: "p", text: "Users must provide accurate information and keep their login credentials secure." },
        { t: "h2", text: "Subscription Plans" },
        { t: "p", text: "Dairy Hub ERP may offer Monthly and Yearly subscription plans. Prices and included features are displayed before purchase." },
        { t: "h2", text: "Payments" },
        { t: "p", text: "Payments are processed through Razorpay or another authorized payment provider. Subscription activation or plan changes occur after successful payment verification." },
        { t: "h2", text: "Subscription Renewal" },
        { t: "p", text: "Where automatic renewal is enabled, subscriptions may renew according to the selected billing cycle. Users may cancel renewal according to the available cancellation process." },
        { t: "h2", text: "Upgrade and Downgrade" },
        { t: "p", text: "Users may upgrade or downgrade plans where supported. Applicable charges and effective dates will be shown during the plan-change process." },
        { t: "h2", text: "Acceptable Use" },
        { t: "p", text: "Users must not:" },
        { t: "ul", items: ["Use Dairy Hub ERP for unlawful activities", "Attempt unauthorized access", "Interfere with system security", "Upload malicious software", "Abuse or misuse the service", "Copy, resell, or redistribute the software without authorization"] },
        { t: "h2", text: "Service Availability" },
        { t: "p", text: "We aim to provide reliable service but cannot guarantee uninterrupted availability." },
        { t: "h2", text: "User Data" },
        { t: "p", text: "Users are responsible for data entered into their account and must have the necessary rights to use that data." },
        { t: "h2", text: "Suspension or Termination" },
        { t: "p", text: "Accounts may be suspended or terminated for violation of these Terms, fraud, security risks, non-payment, or misuse." },
        { t: "h2", text: "Intellectual Property" },
        { t: "p", text: "Dairy Hub ERP software, design, branding, logos, and related intellectual property belong to Dairy Hub ERP / Sunil Gangadhar Kamble unless otherwise stated." },
        { t: "h2", text: "Limitation of Liability" },
        { t: "p", text: "To the extent permitted by applicable law, Dairy Hub ERP / Sunil Gangadhar Kamble will not be responsible for indirect or consequential losses arising from use or inability to use the service." },
        { t: "h2", text: "Changes" },
        { t: "p", text: "We may update these Terms from time to time." },
        { t: "contact" },
      ],
    },
    mr: {
      title: "अटी व शर्ती",
      effectiveDate: "१५/०८/२०२६",
      blocks: [
        { t: "p", text: "या अटी Dairy Hub ERP वेबसाइट व सॉफ्टवेअर सेवांच्या वापरावर लागू होतात, ज्या Sunil Gangadhar Kamble यांच्या मालकीच्या व संचालित Dairy Hub ERP द्वारे पुरवल्या जातात." },
        { t: "p", text: "Dairy Hub ERP नोंदणी किंवा वापर करून, आपण या अटींना संमती देता." },
        { t: "h2", text: "Dairy Hub ERP" },
        { t: "p", text: "Dairy Hub ERP ही एक सॉफ्टवेअर सेवा आहे जी व्यवसायांना दुग्ध-संबंधित कामकाज, नोंदी, वापरकर्ते, सबस्क्रिप्शन व संबंधित क्रियाकलाप व्यवस्थापित करण्यास मदत करते." },
        { t: "h2", text: "खाते नोंदणी" },
        { t: "p", text: "वापरकर्त्यांनी अचूक माहिती द्यावी व त्यांचे लॉगिन क्रेडेन्शियल्स सुरक्षित ठेवावेत." },
        { t: "h2", text: "सबस्क्रिप्शन योजना" },
        { t: "p", text: "Dairy Hub ERP मासिक व वार्षिक सबस्क्रिप्शन योजना देऊ शकते. खरेदीपूर्वी किंमती व समाविष्ट वैशिष्ट्ये दर्शवली जातात." },
        { t: "h2", text: "पेमेंट्स" },
        { t: "p", text: "पेमेंट Razorpay किंवा इतर अधिकृत पेमेंट प्रदात्यामार्फत प्रक्रिया केली जातात. यशस्वी पेमेंट पडताळणीनंतरच सबस्क्रिप्शन सक्रियकरण किंवा योजना बदल होतो." },
        { t: "h2", text: "सबस्क्रिप्शन नूतनीकरण" },
        { t: "p", text: "जिथे स्वयंचलित नूतनीकरण सक्षम असेल तिथे निवडलेल्या बिलिंग चक्रानुसार सबस्क्रिप्शनचे नूतनीकरण होऊ शकते. उपलब्ध रद्दीकरण प्रक्रियेनुसार वापरकर्ते नूतनीकरण रद्द करू शकतात." },
        { t: "h2", text: "अपग्रेड व डाउनग्रेड" },
        { t: "p", text: "जिथे समर्थित असेल तिथे वापरकर्ते योजना अपग्रेड किंवा डाउनग्रेड करू शकतात. योजना-बदल प्रक्रियेदरम्यान लागू शुल्क व अंमलात येण्याची तारीख दर्शवली जाईल." },
        { t: "h2", text: "स्वीकार्य वापर" },
        { t: "p", text: "वापरकर्त्यांनी पुढील गोष्टी करू नयेत:" },
        { t: "ul", items: ["Dairy Hub ERP चा बेकायदेशीर कामांसाठी वापर", "अनधिकृत प्रवेशाचा प्रयत्न", "सिस्टम सुरक्षेमध्ये अडथळा", "दुर्भावनापूर्ण सॉफ्टवेअर अपलोड करणे", "सेवेचा गैरवापर किंवा दुरुपयोग", "अधिकृततेशिवाय सॉफ्टवेअर कॉपी, पुनर्विक्री किंवा पुनर्वितरण"] },
        { t: "h2", text: "सेवा उपलब्धता" },
        { t: "p", text: "आम्ही विश्वासार्ह सेवा देण्याचा प्रयत्न करतो पण अखंडित उपलब्धतेची हमी देऊ शकत नाही." },
        { t: "h2", text: "वापरकर्ता डेटा" },
        { t: "p", text: "आपल्या खात्यात भरलेल्या डेटाची जबाबदारी वापरकर्त्यांची आहे व तो डेटा वापरण्याचे आवश्यक हक्क त्यांच्याकडे असावेत." },
        { t: "h2", text: "स्थगिती किंवा समाप्ती" },
        { t: "p", text: "या अटींचे उल्लंघन, फसवणूक, सुरक्षा धोका, थकबाकी किंवा गैरवापरामुळे खाती स्थगित किंवा समाप्त केली जाऊ शकतात." },
        { t: "h2", text: "बौद्धिक संपदा" },
        { t: "p", text: "अन्यथा नमूद केल्याशिवाय, Dairy Hub ERP सॉफ्टवेअर, डिझाइन, ब्रँडिंग, लोगो व संबंधित बौद्धिक संपदा Dairy Hub ERP / Sunil Gangadhar Kamble यांची आहे." },
        { t: "h2", text: "उत्तरदायित्वाची मर्यादा" },
        { t: "p", text: "लागू कायद्याने परवानगी दिलेल्या मर्यादेपर्यंत, सेवेच्या वापरामुळे किंवा वापर करता न आल्यामुळे होणाऱ्या अप्रत्यक्ष किंवा परिणामी नुकसानीस Dairy Hub ERP / Sunil Gangadhar Kamble जबाबदार राहणार नाहीत." },
        { t: "h2", text: "बदल" },
        { t: "p", text: "आम्ही या अटी वेळोवेळी अद्ययावत करू शकतो." },
        { t: "contact" },
      ],
    },
  },

  refunds: {
    en: {
      title: "Cancellation & Refund Policy",
      effectiveDate: "15/08/2026",
      blocks: [
        { t: "p", text: "This policy applies to Dairy Hub ERP subscriptions." },
        { t: "h2", text: "Subscription Cancellation" },
        { t: "p", text: "Users may cancel their subscription from their Dairy Hub ERP account where cancellation functionality is available. Cancellation normally stops future renewal. Unless otherwise stated, the subscription may remain active until the end of the paid billing period." },
        { t: "h2", text: "Refunds" },
        { t: "p", text: "Subscription payments are generally non-refundable after activation and service availability." },
        { t: "p", text: "Refunds may be considered for:" },
        { t: "ul", items: ["Duplicate payment", "Payment deducted but subscription was not activated due to a technical issue", "Incorrect amount charged due to our error", "Other cases approved by Dairy Hub ERP"] },
        { t: "p", text: "Refund requests will be reviewed case-by-case." },
        { t: "h2", text: "Failed Payments" },
        { t: "p", text: "If payment fails, the subscription may remain pending or may not be activated. Users may retry payment where available." },
        { t: "h2", text: "Refund Processing" },
        { t: "p", text: "Approved refunds will normally be processed through the original payment method where technically possible. Processing time may depend on the payment provider or bank." },
        { t: "h2", text: "Upgrade / Downgrade" },
        { t: "p", text: "Applicable charges or adjustments will be shown during plan changes. Downgrades may take effect at the end of the current billing period." },
        { t: "h2", text: "Refund Request" },
        { t: "email", text: "Email:", mail: "support@dairyhuberp.com" },
        { t: "p", text: "Please include:" },
        { t: "ul", items: ["Registered email", "Payment/transaction ID", "Subscription plan", "Payment date", "Reason for refund request"] },
        { t: "h2", text: "Payment Gateway" },
        { t: "p", text: "Payments are processed through Razorpay. Customer service and refund decisions for Dairy Hub ERP are handled by Dairy Hub ERP / Sunil Gangadhar Kamble." },
        { t: "contact" },
      ],
    },
    mr: {
      title: "रद्दीकरण व परतावा धोरण",
      effectiveDate: "१५/०८/२०२६",
      blocks: [
        { t: "p", text: "हे धोरण Dairy Hub ERP सबस्क्रिप्शनला लागू होते." },
        { t: "h2", text: "सबस्क्रिप्शन रद्दीकरण" },
        { t: "p", text: "जिथे रद्दीकरण सुविधा उपलब्ध असेल तिथे वापरकर्ते त्यांच्या Dairy Hub ERP खात्यातून सबस्क्रिप्शन रद्द करू शकतात. रद्दीकरणामुळे साधारणपणे भविष्यातील नूतनीकरण थांबते. अन्यथा नमूद केल्याशिवाय, भरलेल्या बिलिंग कालावधीच्या शेवटपर्यंत सबस्क्रिप्शन सक्रिय राहू शकते." },
        { t: "h2", text: "परतावा" },
        { t: "p", text: "सक्रियकरण व सेवा उपलब्धतेनंतर सबस्क्रिप्शन पेमेंट सामान्यतः परत केले जात नाही." },
        { t: "p", text: "पुढील प्रकरणांमध्ये परताव्याचा विचार केला जाऊ शकतो:" },
        { t: "ul", items: ["दुबार पेमेंट", "पेमेंट कापले गेले पण तांत्रिक अडचणीमुळे सबस्क्रिप्शन सक्रिय झाले नाही", "आमच्या चुकीमुळे चुकीची रक्कम आकारली गेली", "Dairy Hub ERP ने मंजूर केलेली इतर प्रकरणे"] },
        { t: "p", text: "परतावा विनंत्यांचा प्रत्येक प्रकरणानुसार आढावा घेतला जाईल." },
        { t: "h2", text: "अयशस्वी पेमेंट्स" },
        { t: "p", text: "पेमेंट अयशस्वी झाल्यास, सबस्क्रिप्शन प्रलंबित राहू शकते किंवा सक्रिय होणार नाही. जिथे उपलब्ध असेल तिथे वापरकर्ते पुन्हा पेमेंट करू शकतात." },
        { t: "h2", text: "परतावा प्रक्रिया" },
        { t: "p", text: "मंजूर परतावे तांत्रिकदृष्ट्या शक्य असेल तिथे मूळ पेमेंट पद्धतीद्वारे प्रक्रिया केले जातील. प्रक्रिया वेळ पेमेंट प्रदाता किंवा बँकेवर अवलंबून असू शकते." },
        { t: "h2", text: "अपग्रेड / डाउनग्रेड" },
        { t: "p", text: "योजना बदलादरम्यान लागू शुल्क किंवा समायोजन दर्शवले जाईल. डाउनग्रेड सध्याच्या बिलिंग कालावधीच्या शेवटी अंमलात येऊ शकतात." },
        { t: "h2", text: "परतावा विनंती" },
        { t: "email", text: "ईमेल:", mail: "support@dairyhuberp.com" },
        { t: "p", text: "कृपया पुढील माहिती समाविष्ट करा:" },
        { t: "ul", items: ["नोंदणीकृत ईमेल", "पेमेंट/व्यवहार आयडी", "सबस्क्रिप्शन योजना", "पेमेंट तारीख", "परतावा विनंतीचे कारण"] },
        { t: "h2", text: "पेमेंट गेटवे" },
        { t: "p", text: "पेमेंट Razorpay मार्फत प्रक्रिया केली जातात. Dairy Hub ERP साठी ग्राहक सेवा व परतावा निर्णय Dairy Hub ERP / Sunil Gangadhar Kamble यांच्याद्वारे हाताळले जातात." },
        { t: "contact" },
      ],
    },
  },

  shipping: {
    en: {
      title: "Shipping & Digital Service Delivery Policy",
      effectiveDate: "15/08/2026",
      blocks: [
        { t: "p", text: "Dairy Hub ERP is a digital software service. We do not ship physical products." },
        { t: "h2", text: "Digital Service Delivery" },
        { t: "p", text: "After successful payment verification, the Dairy Hub ERP subscription is activated electronically and users can access the subscribed features through their account." },
        { t: "h2", text: "Delivery Time" },
        { t: "p", text: "For successful payments, subscription activation is normally automatic after payment verification." },
        { t: "h2", text: "No Physical Shipping" },
        { t: "p", text: "No physical product, parcel, courier, or shipping service is involved in a Dairy Hub ERP subscription." },
        { t: "h2", text: "Failed Payment" },
        { t: "p", text: "If payment fails or cannot be verified, the subscription may not be activated until successful payment confirmation." },
        { t: "h2", text: "Service Access" },
        { t: "p", text: "Access depends on the purchased subscription plan and account status." },
        { t: "h2", text: "Support" },
        { t: "p", text: "For subscription activation or service-access issues, please contact us." },
        { t: "contact" },
      ],
    },
    mr: {
      title: "शिपिंग व डिजिटल सेवा वितरण धोरण",
      effectiveDate: "१५/०८/२०२६",
      blocks: [
        { t: "p", text: "Dairy Hub ERP ही एक डिजिटल सॉफ्टवेअर सेवा आहे. आम्ही कोणतीही भौतिक उत्पादने पाठवत नाही." },
        { t: "h2", text: "डिजिटल सेवा वितरण" },
        { t: "p", text: "यशस्वी पेमेंट पडताळणीनंतर Dairy Hub ERP सबस्क्रिप्शन इलेक्ट्रॉनिकरित्या सक्रिय होते व वापरकर्ते त्यांच्या खात्याद्वारे सबस्क्राइब केलेल्या वैशिष्ट्यांचा वापर करू शकतात." },
        { t: "h2", text: "वितरण वेळ" },
        { t: "p", text: "यशस्वी पेमेंटसाठी, पेमेंट पडताळणीनंतर सबस्क्रिप्शन सक्रियकरण साधारणपणे स्वयंचलित असते." },
        { t: "h2", text: "भौतिक शिपिंग नाही" },
        { t: "p", text: "Dairy Hub ERP सबस्क्रिप्शनमध्ये कोणतेही भौतिक उत्पादन, पार्सल, कुरिअर किंवा शिपिंग सेवा समाविष्ट नाही." },
        { t: "h2", text: "अयशस्वी पेमेंट" },
        { t: "p", text: "पेमेंट अयशस्वी झाल्यास किंवा पडताळणी होऊ न शकल्यास, यशस्वी पेमेंट पुष्टीपर्यंत सबस्क्रिप्शन सक्रिय होणार नाही." },
        { t: "h2", text: "सेवा प्रवेश" },
        { t: "p", text: "प्रवेश खरेदी केलेल्या सबस्क्रिप्शन योजनेवर व खात्याच्या स्थितीवर अवलंबून असतो." },
        { t: "h2", text: "सहाय्य" },
        { t: "p", text: "सबस्क्रिप्शन सक्रियकरण किंवा सेवा-प्रवेशाच्या अडचणींसाठी कृपया आमच्याशी संपर्क साधा." },
        { t: "contact" },
      ],
    },
  },

  contact: {
    en: {
      title: "Contact Us",
      effectiveDate: null,
      blocks: [
        { t: "p", text: "Contact us for questions about Dairy Hub ERP, subscriptions, payments, accounts, and technical support." },
        { t: "contact" },
        { t: "p", text: "For payment or subscription issues, include your registered email address and payment/transaction ID." },
      ],
    },
    mr: {
      title: "आमच्याशी संपर्क साधा",
      effectiveDate: null,
      blocks: [
        { t: "p", text: "Dairy Hub ERP, सबस्क्रिप्शन, पेमेंट, खाती व तांत्रिक सहाय्याबाबतच्या प्रश्नांसाठी आमच्याशी संपर्क साधा." },
        { t: "contact" },
        { t: "p", text: "पेमेंट किंवा सबस्क्रिप्शन अडचणींसाठी, आपला नोंदणीकृत ईमेल पत्ता व पेमेंट/व्यवहार आयडी समाविष्ट करा." },
      ],
    },
  },
};
